export const NOT_SELECTED_STYLE_ID = 'not_selected'

export const NOT_SELECTED_STYLE = {
  id: NOT_SELECTED_STYLE_ID
}
